<template>
  <div id="not-found">
    <h1>404 Not Found</h1>
    <h2>Страница не существует или ссылка устарела.</h2>
    <h2><a href="/">Главная страница</a></h2>
  </div>
</template>

<script>
  export default {}
</script>

<style scoped lang="scss">
  #not-found {
    padding: 10px;

    h1, h2 {
      margin-bottom: 10px;
    }

    a {
      color: #4683ea;
      text-decoration: underline;
    }
  }
</style>